// Token store over localStorage. `LOGOUT` is the action type middleware/
// notification.js dispatches on an HTTP 401.
//
// The `authMiddleware` that used to live at the bottom of this file was
// removed in the Wave-4 cleanup: redux/Store.js has always applied
// `notificationMiddleware` instead, so nothing ever ran it, and the
// `AUTH_SUCCESS` / `AUTH_REQUIRED` action types it switched on were never
// dispatched by any reducer or action creator in the app. Token writes go
// through services/jwtAuthService.setSession() / SignInForm.
export const LOGOUT = 'LOGOUT';

const localStorage = window.localStorage;

export const auth = {
  setToken(token) {
    localStorage.setItem('token', token);
  },

  getToken() {
    return localStorage.getItem('token');
  },

  loggedIn() {
    return localStorage.getItem('token') !== null;
  },

  logout() {
    localStorage.removeItem('token');
  },

  havePermissions(user, permissions) {
    if (!permissions || permissions.length === 0) return true;
    if (!user || !user.permissions) return false;
    const permissionsValues = permissions.map(permission =>
      user.permissions.indexOf(permission) > -1,
    );
    const havePermissions = permissionsValues.indexOf(true) > -1;
    return havePermissions;
  },
};
